import service from "../../../lib";
import { AxiosResponse } from "axios";


type AddTransactionParams<TBody = any> = {
  body: TBody;
};


export type TransactionResponse<T = any> = AxiosResponse<T>;

const transactionApi = {
  addTransaction: <T = any, TBody = any>({
    body,
  }: AddTransactionParams<TBody>): Promise<TransactionResponse<T>> => {
    return service.post<T>("/payment-orders", body);
  },
}

  export default transactionApi;